// Column configuration for Model Reviewer/Preparer Dashboard
import { MODELS_COLUMN_IDS, MODELS_COLUMN_LABELS } from './constants';

const col = (id: string, label: string, isSortable = true, align = 'left' as const, disablePadding = false) => ({
  id,
  label,
  isSortable,
  align,
  disablePadding,
});

export const modelsColumns = [
  col(MODELS_COLUMN_IDS.COMPANY_NAME, MODELS_COLUMN_LABELS.COMPANY_NAME),
  col(MODELS_COLUMN_IDS.VALUATION_STATUS, MODELS_COLUMN_LABELS.VALUATION_STATUS),
  col(MODELS_COLUMN_IDS.MODEL_STATUS, MODELS_COLUMN_LABELS.MODEL_STATUS),
  col(MODELS_COLUMN_IDS.SUPPORTING_DUE_DATE, MODELS_COLUMN_LABELS.SUPPORTING_DUE_DATE),
  col(MODELS_COLUMN_IDS.NOTES, MODELS_COLUMN_LABELS.NOTES),
  col(MODELS_COLUMN_IDS.MODEL_REVIEWER, MODELS_COLUMN_LABELS.MODEL_REVIEWER),
  col(MODELS_COLUMN_IDS.MODEL_PREPARER, MODELS_COLUMN_LABELS.MODEL_PREPARER),
  col(MODELS_COLUMN_IDS.VALUATION_LEAD, MODELS_COLUMN_LABELS.VALUATION_LEAD),
  col(MODELS_COLUMN_IDS.VALUATION_DATE, MODELS_COLUMN_LABELS.VALUATION_DATE),
];
